export default {
    "add": {
        "colors": "primary",
        "hotkey": "alt+n",
        "className": "ac-btns-add",
        "name": "新增"
    },
    "confirm": {
        "colors": "primary",
        "className": "ac-btns-confirm",
        "name": "确认"
    },
    "detail": {
        "colors": "write",
        "className": "ac-btns-detail",
        "name": "详情"
    },
    "search": {
        "colors": "primary",
        "hotkey": "ctrl+enter",
        "className": "ac-btns-search",
        "name": "查询"
    },
    "clear": {
        "colors": "write",
        "hotkey": "ctrl+r",
        "className": "ac-btns-clear",
        "name": "清空"
    },
    "empty": {
        "colors": "write",
        "hotkey": "ctrl+r",
        "className": "ac-btns-empty",
        "name": "清空"
    },
    "export": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-export",
        "name": "导出"
    },
    "import": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-import",
        "name": "导入"
    },
    "template": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-template",
        "name": "导入模板下载"
    },
    "save": {
        "colors": "primary",
        "hotkey": "",
        "className": "ac-btns-save",
        "name": "保存"
    },
    "cancel": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-cancel",
        "name": "取消"
    },
    "update": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-update",
        "name": "修改"
    },
    "delete": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-delete",
        "name": "删除"
    },
    "pbmsubmit": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-pbmsubmit",
        "name": "提交"
    },
    "pbmcancle": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-pbmcancle",
        "name": "撤回"
    },
    "pbmapprove": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-pbmapprove",
        "name": "审批"
    },
    "appoint": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-appoint",
        "name": "指派"
    },
    "send": {
        "colors": "write",
        "hotkey": "",
        "className": "ac-btns-send",
        "name": "发送"
    },
    "printpreview": {
        "colors": "write",
        "className": "ac-btns-printpreview",
        "name": "打印预览"
    },
    "printdesign": {
        "colors": "write",
        "className": "ac-btns-printdesign",
        "name": "打印设计"
    },
    "upload": {
        "colors": "primary",
        "className": "ac-btns-upload",
        "name": "上传"
    },
    "reupload": {
        "colors": "primary",
        "className": "ac-btns-reupload",
        "name": "重新上传"
    },
    "download": {
        "colors": "write",
        "className": "ac-btns-download",
        "name": "下载"
    },
    "addRow": {
        "colors": "write",
        "className": "ac-btns-addRow",
        "name": "增行"
    },
    "delRow": {
        "colors": "write",
        "className": "ac-btns-delRow",
        "name": "删行"
    },
    "copyRow": {
        "colors": "write",
        "className": "ac-btns-copyRow",
        "name": "复制行"
    },
    "max": {
        "colors": "write",
        "className": "ac-btns-max",
        "name": "最大化"
    },
    "min": {
        "colors": "write",
        "className": "ac-btns-min",
        "name": "min"
    },
    "copyToEnd": {
        "colors": "write",
        "className": "ac-btns-copyToEnd",
        "name": "粘贴至末行"
    },
    "copyToHere": {
        "colors": "write",
        "className": "ac-btns-copyToHere",
        "name": "粘贴至此处"
    },
    "organizationChat": {
        "colors": "write",
        "className": "ac-btns-organizationChat",
        "name": "机构图"
    },
    "enable": {
        "colors": "write",
        "className": "ac-btns-enable",
        "name": "启用"
    },
    "disabled": {
        "colors": "write",
        "className": "ac-btns-disabled",
        "name": "停用"
    },
    "next": {
        "colors": "write",
        "className": "ac-btns-next",
        "name": "下一条"
    },
    "previous": {
        "colors": "write",
        "className": "ac-btns-previous",
        "name": "上一条"
    },
    "first": {
        "colors": "write",
        "className": "ac-btns-first",
        "name": "第一条"
    },
    "last": {
        "colors": "write",
        "className": "ac-btns-last",
        "name": "最后一条"
    }
}


// WEBPACK FOOTER //
// ./src/btnJSON.js